import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
	async [actionTypes.FORNECEDOR.BUSCAR_FORNECEDORES_POR_FILTRO]({ state }, filtro) {
		const { paginacao } = state
		const { data } = await api.fornecedor.buscarPorFiltro(filtro, paginacao)
		return data
	},
}
